import _ from 'underscore';
import ko from 'knockout';
import Form from '@bingads-webui-component-legacy/form/view/simple-form';
import template from '@bingads-webui-campaign-legacy/adextension-price/template/tablerow.pug';
import { getSchemas } from '@bingads-webui-campaign-legacy/adextension-price/utility';

const s$i18n = window.globalLegacyI18n.get('$/schema-i18n!campaign');

export default class TableRowView extends Form {
  initialize(options = {}) {
    const { tableRowSchema: schema } = getSchemas();

    const opt = _.defaults(options, {
      schema,
      fields: [{
        property: 'Header',
        showHintInline: true,
      }, {
        property: 'Description',
        showHintInline: true,
      }, 'PriceQualifier', 'CurrencyCode', 'Price', 'PriceUnit', 'FinalUrls', 'FinalMobileUrls'],
      template,
      s$i18n,
      hasButtons: false,
      hasLabels: false,
    });

    super.initialize(opt);

    this.viewModel.$aggregatedErrors = ko.computed(() => {
      const errors = this.viewModel.Header.errors()
        .concat(this.viewModel.Description.errors())
        .concat(this.viewModel.PriceQualifier.errors())
        .concat(this.viewModel.CurrencyCode.errors())
        .concat(this.viewModel.Price.errors())
        .concat(this.viewModel.PriceUnit.errors())
        .concat(this.viewModel.FinalUrls.errors())
        .concat(this.viewModel.FinalMobileUrls.errors())
        .concat(this.viewModel.$overall.errors());

      return _.uniq(errors);
    });
    this.viewModel.$hasAggregatedErrors = ko.computed(() => {
      return _.size(this.viewModel.$aggregatedErrors()) > 0;
    });
  }
}
